/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Avglatency1Inputs */

const zh_analytics_avglatency1 = /** @type {(inputs: Analytics_Avglatency1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均延迟`)
};

const en_analytics_avglatency1 = /** @type {(inputs: Analytics_Avglatency1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg Latency`)
};

const es_analytics_avglatency1 = /** @type {(inputs: Analytics_Avglatency1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latencia prom.`)
};

/**
* | output |
* | --- |
* | "Avg Latency" |
*
* @param {Analytics_Avglatency1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_avglatency1 = /** @type {((inputs?: Analytics_Avglatency1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Avglatency1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_avglatency1(inputs)
	if (locale === "en") return en_analytics_avglatency1(inputs)
	return es_analytics_avglatency1(inputs)
});
export { analytics_avglatency1 as "analytics_avgLatency" }